import { LogoProps } from './types';

const QodoAnteater = ({ className = '', size = 24 }: LogoProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1453_4271)">
      <path
        d="M15.1194 29.8251C22.8392 29.8251 29.0973 23.567 29.0973 15.8472C29.0973 8.12748 22.8392 1.86938 15.1194 1.86938C7.39969 1.86938 1.1416 8.12748 1.1416 15.8472C1.1416 23.567 7.39969 29.8251 15.1194 29.8251Z"
        fill="#7968FA"
      />
      <mask
        id="mask0_1453_4271"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="34"
        height="30"
      >
        <path
          d="M34.4555 20.8945C34.4555 28.8501 23.5022 30.0578 15.5465 30.0578C7.59095 30.0578 1.1416 23.6084 1.1416 15.6527C1.1416 7.69715 7.59095 1.2478 15.5465 1.2478C23.5022 1.2478 34.4555 12.9388 34.4555 20.8945Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1453_4271)">
        <path
          d="M14.6372 10.8626L14.9284 8.41872C14.9284 8.41872 15.167 7.40847 16.2544 7.58458C17.3417 7.76065 17.1807 8.69683 17.1807 8.69683C17.1807 9.53097 16.0375 11.2179 16.0375 11.2179"
          fill="white"
        />
        <path
          d="M14.6372 10.8626L14.9284 8.41872C14.9284 8.41872 15.167 7.40847 16.2544 7.58458C17.3417 7.76065 17.1807 8.69683 17.1807 8.69683C17.1807 9.53097 16.0375 11.2179 16.0375 11.2179"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.8246 22.9753L30.5848 24.3532C30.6375 24.4459 25.5661 22.1441 20.6589 20.9671C17.9668 20.3213 15.3242 19.8023 13.5429 20.9176C8.70388 23.9485 7.94794 40.4282 3.4652 46.9471C3.4652 46.9471 4.12196 51.3096 3.53025 55.6968C2.72478 61.6658 -2.08945 64.2765 -2.49838 64.2888C5.87541 63.8161 5.5842 66.785 5.5842 66.785C5.5842 66.785 0.717304 66.7914 -4.54304 66.7946C-5.86896 66.7946 -6.74878 66.7914 -6.91298 66.785C-7.8083 66.7606 -6.83242 64.0942 -6.83242 64.0942C-7.9539 63.4979 -8.8616 62.1941 -9.22097 61.1962L-13.7688 64.0448L-12.3406 66.7978C-15.1288 66.7978 -17.1858 66.7946 -17.446 66.785C-18.3413 66.7606 -17.3655 63.7389 -17.3655 63.7389C-20.1382 62.1138 -20.8662 57.7204 -20.8662 57.7204C-20.8662 57.7204 -23.1866 47.8277 -17.8302 34.9782C-15.6028 29.6333 -12.3437 23.6673 -6.52571 17.9084C1.20059 10.2617 8.87423 8.25661 15.2127 9.83848C26.2569 12.5913 32.3506 21.4305 32.8246 22.9753Z"
          fill="white"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.0346 11.6722L6.72418 9.89879C6.72418 9.89879 5.9528 8.42506 7.22914 7.95543C8.50551 7.48582 9.0074 8.7927 9.07552 9.12636C9.1437 9.46007 9.61147 11.1006 9.61147 11.1006"
          fill="white"
        />
        <path
          d="M8.0346 11.6722L6.72418 9.89879C6.72418 9.89879 5.9528 8.42506 7.22914 7.95543C8.50551 7.48582 9.0074 8.7927 9.07552 9.12636C9.1437 9.46007 9.61147 11.1006 9.61147 11.1006"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.5938 23.4126L31.8063 21.3364L32.7822 22.838L30.5857 24.3519L28.5938 23.4126Z"
          fill="#7968FA"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1934 13.4116C13.1934 13.4116 13.5404 13.6279 13.5404 14.1006C13.5404 14.5733 13.4753 16.1861 15.5881 16.1861C17.7009 16.1861 17.6575 14.6815 17.6575 13.4333"
          fill="black"
        />
        <path
          d="M13.1934 13.4116C13.1934 13.4116 13.5404 13.6279 13.5404 14.1006C13.5404 14.5733 13.4753 16.1861 15.5881 16.1861C17.7009 16.1861 17.6575 14.6815 17.6575 13.4333"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9491 13.4116C23.9491 13.4116 23.6021 13.6279 23.6021 14.1006C23.6021 14.5733 23.6672 16.1861 21.5544 16.1861C19.4416 16.1861 19.4849 14.6815 19.4849 13.4333"
          fill="black"
        />
        <path
          d="M23.9491 13.4116C23.9491 13.4116 23.6021 13.6279 23.6021 14.1006C23.6021 14.5733 23.6672 16.1861 21.5544 16.1861C19.4416 16.1861 19.4849 14.6815 19.4849 13.4333"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6636 13.3491H24.4791"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6118 14.0171C19.6118 13.7421 19.3206 13.3992 18.5988 13.3992C17.8769 13.3992 17.5269 13.7483 17.5269 14.0171"
          stroke="black"
          strokeWidth="0.464695"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M28.9742 17.8662C29.0554 17.2566 29.0974 16.6344 29.0974 16.0025C29.0974 8.28276 22.8393 2.02466 15.1194 2.02466C7.39969 2.02466 1.1416 8.28276 1.1416 16.0025C1.1416 23.7223 7.39969 29.9804 15.1194 29.9804C20.2289 29.9804 24.698 27.239 27.1362 23.1468"
        stroke="#0E0F10"
        strokeWidth="0.465929"
      />
    </g>
    <defs>
      <clipPath id="clip0_1453_4271">
        <rect
          width="32"
          height="30.1176"
          fill="white"
          transform="translate(0.5 0.941162)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default QodoAnteater;
